<template>
  <div>
    <detail-label
      label="Service Category:"
      :value="serviceCategoryLabel"
      class="mb-2"
    ></detail-label>
    <detail-label
      label="Duration:"
      :value="
        durationLabel(
          appointment.duration_minutes ||
            appointment.estimated_duration_minutes,
          appointment.service_category
        )
      "
      class="mb-2"
    ></detail-label>
    <detail-label
      :label="technicianHeaderLabel"
      :value="technicianLabel"
      class="mb-2"
    ></detail-label>
    <detail-label label="Scheduled:" :value="scheduledLabel"></detail-label>
  </div>
</template>

<script>
import DetailLabel from "@/components/DetailLabel.vue";

export default {
  components: {
    DetailLabel
  },
  props: {
    appointment: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    serviceCategoryLabel() {
      return this.appointment.service_category
        ? this.appointment.service_category.name
        : "--";
    },
    scheduledLabel() {
      return this.scheduledDateTime(
        this.appointment.scheduled_time,
        this.appointment.arrival_window_start,
        this.appointment.arrival_window_end
      );
    },
    technicianHeaderLabel() {
      const techs = this.appointment.technicians;
      return techs && techs.length > 1 ? "Technicians:" : "Technician:";
    },
    technicianLabel() {
      const { assignment_pinned, pinned_reason } = this.appointment;
      const techs = this.resolveAssignedTechnicians(this.appointment);
      return this.assignedTechniciansLabel(
        techs,
        assignment_pinned,
        pinned_reason
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
